// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const FolderOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"viewBox":"0 0 512 512","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M64 480h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H288c-10.1 0-19.6-4.7-25.6-12.8l-19.2-25.6A64.13 64.13 0 00192 32H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64z"}}]},"name":"folder","theme":"outlined"};

const FolderOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={FolderOutlinedSvg} />;
  FolderOutlined.displayName = 'FolderOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(FolderOutlined);
